export default __webpack_public_path__ + "static/media/myrp.311a8f3c.png";